(function(){
    'use strict'; 
    angular.module('Directives').directive('bbaReconcileCarrierInvoiceDetails', bbaReconcileCarrierInvoiceDetails); 
    bbaReconcileCarrierInvoiceDetails.$inject = [
        '$q',
        'Carrier',
        'toastr',
        'scrollToForm', 
        'AccountingService',
        '$location',
        '$routeParams'
    ]; 

    /**
     * @directive   bbaReconcileCarrierInvoiceDetails    
     * @description Generate panneled view for reconcile carrier invoice details.
     * 
     * @param       { Object } - Holds the invoice details data 
     */
    function bbaReconcileCarrierInvoiceDetails(
        $q,
        Carrier,
        toastr,
        scrollToForm,
        AccountingService,
        $location,
        $routeParams
    ){
        return {
            restrict: 'E', 
            templateUrl: '/templates/directives/components/accounting/bbaReconcileCarrierInvoiceDetails.html', 
            scope: {
                invoiceDetailsData: '=',
                updateCallback    : '='
            }, 
            link: bbaReconcileCarrierInvoiceDetailsLink
        }

        function bbaReconcileCarrierInvoiceDetailsLink($scope, $elems, $attrs) {
            $scope.invoiceShimpentSourceData = [
                {name: 'THIRD PARTY', value: 'third_party'}
            ];
            $scope.accountNumbers = [];

            $scope.save            = save;
            $scope.back            = back;
            $scope.updateMainData  = updateMainData;
            
            init();

            /**
             * @function    init
             * @description Initialize all the methods that needed to be run when the directive is called 
             * 
             */
            function init(){
                if(!$routeParams.id){
                    $scope.invoiceData = initializeInvoiceData($scope.invoiceDetailsData);
                    return
                }
                
                $q.all([loadCarriers()]).then(data => {
                    $scope.invoiceData = initializeInvoiceData($scope.invoiceDetailsData);
                    setViewModeStatus();
                    isShowAccountNumber();
                });
            }

            function isShowAccountNumber() {
                $scope.isShowAccountNumber = Object.keys($scope.invoiceDetailsData).length > 1;
            }

            /**
             * @function setViewModeStatus
             * @description Set the fields to disabled if the invoiceDetailsData.shipment property is not empty
             *
             */
            function setViewModeStatus(){
                if(angular.getObjVal($scope.invoiceDetailsData, 'shipments')) {
                    $scope.isViewMode = $scope.invoiceDetailsData.shipments.length !== 0 ? true : false;
                } else {
                    $scope.isViewMode = false;
                }
            }

            function loadCarriers() {
                const deffered = $q.defer();
                Carrier.getCarriers(data => {
                    $scope.carriers = data;
                    deffered.resolve(data);
                }, error => {
                    toastr.error(error.message, 'Error');
                    deffered.reject(error);
                });
                return deffered.promise;
            }

            /**
             * @function    initializeInvoiceData
             * @decription  Remove unneeded invoiceDetailsData fields.
             * 
             * @return      { Object } - generated data
             */
            function initializeInvoiceData(invoiceDetailsData){
               
                const generatedData =  {
                    id                   : invoiceDetailsData.id || null,
                    invoiceShipmentSource: invoiceDetailsData.invoiceShipmentSource ? { name: invoiceDetailsData.invoiceShipmentSource.split('_').join(' ').toUpperCase(), value: invoiceDetailsData.invoiceShipmentSource} : null,
                    accountNumber        : invoiceDetailsData.accountNumber || null, 
                    carrier              : invoiceDetailsData.carrier ? $scope.carriers.find(item =>item.id === invoiceDetailsData.carrier.carrierId)  : null, 
                    invoiceNumber        : invoiceDetailsData.invoiceNumber || null,
                    salesTaxPercent      : invoiceDetailsData.salesTaxPercent || 0,
                    fuelLevyPercent      : invoiceDetailsData.fuelLevyPercent || 0
                }

                return generatedData; 
            }

            /**
             * @function    updateMainData
             * @description This method will update the invoiceDetailsData. This method is essential for checking 
             *              if there are user changes in the data.
             *              
             */
            function updateMainData(){
            //    $scope.invoiceData
            //     if($scope.invoiceDetailsData != {}) {
            //         $scope.invoiceDetailsData.invoiceShipmentSource = $scope.invoiceData.invoiceShipmentSource ? $scope.invoiceData.invoiceShipmentSource.value : null; 
            //         $scope.invoiceDetailsData.invoiceNumber         = $scope.invoiceData.invoiceNumber; 
            //         $scope.invoiceDetailsData.salesTaxPercent       = $scope.invoiceData.salesTaxPercent || 0; 
            //         $scope.invoiceDetailsData.fuelLevyPercent       = $scope.invoiceData.fuelLevyPercent;

            //         if(angular.getObjVal($scope.invoiceDetailsData, 'carrier.carrierId') && angular.getObjVal($scope.invoiceData, 'carrier.id')) {
            //             $scope.invoiceDetailsData.carrier.carrierId     = $scope.invoiceData.carrier.id; 
            //         }
            //     }
            }

            /**
             * @function    save
             * @description Update or create new invoice data
             * 
             * @param       { Object } form
             */
            function save(form){
                $scope.savingInvoiceData = true;
                if(form.$invalid) {
                    scrollToForm(form.$name);
                    return false;
                }
                
                const payload = generateInvoiceUpdatePayload($scope.invoiceData);
                if($scope.invoiceData.id) {
                    AccountingService.Invoices.update(data => {
                        $scope.savingInvoiceData = false; 
                        initializeInvoiceData(data);
                        $scope.updateCallback();
                        toastr.success('', 'Invoice successfully updated!');
                    }, error => {
                        toastr.error(error.message || 'Please try again', 'Unable to save invoice.');
                        $scope.savingInvoiceData = false; 
                    }, $scope.invoiceDetailsData.id, payload);
                }
                else {
                    AccountingService.Invoices.create(function(data) {
                        $scope.savingInvoiceData = false; 
                        $location.path('/accounting/invoices/' + data.id);
                        toastr.success('', 'Invoice successfully created!');
                    }, function(error) {
                        $scope.savingInvoiceData = false; 
                        toastr.error(error.message || 'Please try again', 'Unable to save invoice.');
                    }, payload);
                }
            }

            /**
             * @function    generateInvoiceUpdatePayload
             * @description Generate paylaod for updating invoice data.
             * 
             * @param       { Object } invoiceData
             */
            function generateInvoiceUpdatePayload(invoiceData){
                return {
                    invoiceNumber         : invoiceData.invoiceNumber,
                    accountNumber         : invoiceData.accountNumber, 
                    carrierId             : invoiceData.carrier.id, 
                    currency              : $scope.invoiceDetailsData.currency, 
                    dateOfInvoice         : $scope.invoiceDetailsData.dateOfInvoice, 
                    invoiceShipmentSource : invoiceData.invoiceShipmentSource.value, 
                    salesTaxPercent       : invoiceData.salesTaxPercent,
                    surchargeProfileIds   : $scope.invoiceDetailsData.surchargeProfiles ? $scope.invoiceDetailsData.surchargeProfiles.map(item => {
                        return item.id;
                    }) : []
                }
            }

            /**
             * @function    back
             * @description Redirect user to invoices list grid 
             * 
             */
            function back(){
                $location.path('/accounting-invoices');
            }   
        }
    }
})();



// WEBPACK FOOTER //
// ./js/directives/component/accounting/bbaReconcileCarrierInvoiceDetails.js